import { type ReactNode } from "react";

interface BaseButtonProps {
  children: ReactNode;
  onClick?: () => void;
  variant?: "primary" | "secondary" | "ghost";
  size?: "sm" | "md" | "lg";
  className?: string;
  disabled?: boolean;
}

export const BaseButton = ({
  children,
  onClick,
  variant = "secondary",
  size = "sm",
  className = "",
  disabled = false,
}: BaseButtonProps) => {
  const baseStyles =
    "flex items-center gap-1 rounded-[5px] transition-colors font-medium";

  const variantStyles = {
    primary: "bg-white text-dark-5 hover:bg-gray-100",
    secondary: "bg-dark-20 text-dark-text hover:text-white",
    ghost: "text-dark-text hover:text-white",
  };

  const sizeStyles = {
    sm: "text-sm py-1 px-1.5",
    md: "text-sm py-2 px-4",
    lg: "text-base py-2.5 px-5",
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className}`}
    >
      {children}
    </button>
  );
};
